import React from 'react';
import classNames from 'classnames';
import { SIZES } from './constants';
function ButtonSkeleton({ size = SIZES.medium }) {
  const classes = classNames('ws-ui-button-skeleton', `ws-ui-button-skeleton--size-${size}`);

  return (
    <span className={classes}>
      <span>&nbsp;</span>
    </span>
  );
}

export default ButtonSkeleton;
